import React from 'react';
import './footer.scss';

const {
  cookieConsentEnabled,
  cookieConsentLinkTitle,
  cookieConsentUrlPath,
} = window.mobile.features.cookieManagementSettings;

const Footer = () => {
  if (!cookieConsentEnabled) {
    return null;
  }
  return (
    <nav className="app-footer navbar py-2 pr-1 pr-md-3">
      <a className="nav-item navbar-item mx-auto" href={cookieConsentUrlPath}>{cookieConsentLinkTitle}</a>
    </nav>
  );
};

export default Footer;
